<template>
  <div>
    <div class="header-button-bar">
      <el-button @click.stop="showBindDia"
                 type="primary"
                 size="small">{{
        this.$t('device.assignDevice')
      }}</el-button>
      <el-button @click.stop="ubBindEven"
                 type="primary">{{
        this.$t('device.unBindBtn')
      }}</el-button>
    </div>
    <el-table @selection-change="changeUnBindSelection"
              :data="bindList"
              border
              style="width: 100%">
      <el-table-column type="selection"
                       width="55"></el-table-column>
      <el-table-column prop="devSn"
                       :label="this.$t('device.sn')"></el-table-column>
      <el-table-column prop="devAlias"
                       :label="this.$t('device.alias')"></el-table-column>
      <el-table-column prop="devStatus"
                       :label="this.$t('common.status')">
        <template slot-scope="scope">
          <deviceStatus :status="scope.row.devStatus===0 ?1 :0"></deviceStatus>
        </template>
      </el-table-column>

      <el-table-column :label="this.$t('common.action')">
        <template slot-scope="scope">
          <el-tag class="action_btn"
                  @click="viewDevice(scope.row)"
                  type="success">view</el-tag>
          <el-tag class="action_btn"
                  @click="deleteDevice(scope.row)"
                  type="info">
            <i class="el-icon-delete"></i>
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :append-to-body="true"
               :title="this.$t('device.selectDeivces')"
               :visible.sync="bindDialogTableVisible">
      <el-table height="400"
                :data="unBindList"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="55"></el-table-column>
        <el-table-column prop="devSn"
                         :label="this.$t('device.sn')"></el-table-column>
        <el-table-column prop="devAlias"
                         :label="this.$t('device.alias')"></el-table-column>
        <el-table-column prop="devStatus"
                         :label="this.$t('common.status')">
          <template slot-scope="scope">
            <deviceStatus :status="scope.row.devStatus===0 ? 1 : 0"></deviceStatus>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click.stop="cancelBind">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click.stop="submitBind">{{
          $t('common.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findBindDeviceList,
  findUnbindDeviceList,
  bindWorkCodeTypeToDevices,
  unbindWorkCodeTypeToDevices
} from '@/services/workcodeApi.js'
export default {
  data () {
    return {
      workCodeTypeId: '',
      bindDialogTableVisible: false,
      bindList: [],
      unBindList: [],
      unbindSelection: null, // 解绑选中列表
      bindSelection: null // 绑定选中列表
    }
  },
  watch: {
    selectAttCode: {
      handler (newValue, oldValue) {
        this.showAdd = true
        if (newValue) {
          this.workCodeTypeId = newValue.id
          this.bindList = []
          this.getBindList()
        }
      },
      deep: true
    }
  },
  props: {
    selectAttCode: {
      type: Object,
      function () {
        return {}
      }
    }
  },
  mounted () {
    this.getBindList()
  },
  methods: {
    changeUnBindSelection (val) {
      this.unbindSelection = val
    },
    showBindDia () {
      // 点击显示绑定对话框
      this.getUnbindList()
      this.bindDialogTableVisible = true
    },
    ubBindEven () {
      // 批量解除绑定时间
      if (this.unbindSelection.length < 1) {
        this.errorMessage(this.$t('device.selectUnBindDevice'))
        return false
      } else {
        let deviceIds = this.unbindSelection.map((item) => {
          return item.devId + ''
        })
        let params = {
          deviceIds: deviceIds,
          workCodeTypeId: this.workCodeTypeId
        }
        this.setUnbindList(params)
      }
    },
    handleSelectionChange (val) {
      this.bindSelection = val
    },
    viewDevice (row) {
      // 查看设备详情
      this.$router.push({ name: 'deviceList', query: { sn: row.devSn } })
    },

    deleteDevice (row) {
      // 解绑按钮
      let params = {
        deviceIds: [row.devId + ''],
        workCodeTypeId: this.workCodeTypeId
      }
      this.setUnbindList(params)
    },

    cancelBind () {
      // 取消绑定
      this.bindDialogTableVisible = false
    },
    submitBind () {
      // 绑定提交
      if (this.bindSelection.length > 0) {
        let ids = this.bindSelection.map((item) => {
          return item.devId + ''
        })
        let params = {
          deviceIds: ids,
          workCodeTypeId: this.workCodeTypeId
        }
        bindWorkCodeTypeToDevices(params)
          .then((data) => {
            if (data.code === '00000000') {
              this.bindDialogTableVisible = false
              this.getBindList()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch((e) => {
            this.errorMessage()
          })
      } else {
        this.errorMessage(this.$t('common.selectRecod'))
      }
    },

    getBindList () {
      // 绑定列表
      if (!this.workCodeTypeId) {
        if (this.selectAttCode) {
          this.workCodeTypeId = this.selectAttCode.id
        } else {
          return false
        }
      }
      let parms = {
        workCodeTypeId: this.workCodeTypeId
      }
      findBindDeviceList(parms)
        .then((data) => {
          if (data.code === '00000000') {
            this.bindList = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    getUnbindList () {
      // 未绑定列表
      if (!this.workCodeTypeId) {
        if (this.selectAttCode) {
          this.workCodeTypeId = this.selectAttCode.id
        } else {
          return false
        }
      }
      let parms = {
        workCodeTypeId: this.workCodeTypeId
      }
      findUnbindDeviceList(parms)
        .then((data) => {
          if (data.code === '00000000') {
            this.unBindList = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },

    setUnbindList (params) {
      // 解绑
      let _this = this
      this.$confirm(
        this.$t('attendanceCode.unBindWordCode'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          unbindWorkCodeTypeToDevices(params)
            .then((data) => {
              if (data.code === '00000000') {
                _this.getBindList()
              } else {
                _this.errorMessage(data.message)
              }
            })
            .catch((data) => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    }
  }
}
</script>

<style scoped lang="less">
.header-button-bar {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/attendanceCode/workCodeDevice.vue